import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { pdfjs } from 'react-pdf';
import App from './App';
import '@cloudscape-design/global-styles/index.css';
import '@cloudscape-design/global-styles/dark-mode-utils.css';
import './index.css';
import './styles/summit-theme.css';
import './styles/touch-mode.css';

// Configure pdf.js worker for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs`;

// Add global error handler for ResizeObserver errors
const originalConsoleError = console.error;
console.error = function(message, ...args) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    // Suppress ResizeObserver loop errors
    return;
  }
  originalConsoleError.call(console, message, ...args);
};

// Alternative approach using window.addEventListener
window.addEventListener('error', function(e) {
  if (e && e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    return true;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
